module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/socket.io-client/~/has-binary/~/isarray/index.js
// module id = 1131
// module chunks = 0